export default __webpack_public_path__ + "assets/images/Payment_12.114fc7.avif";